import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ReportsService } from '../../../Services/reports.service';
import { LoginService } from '../../../Services/login.service';
import { DashboardService } from '../../../Services/dashboard.service';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-date-order-summary',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbPaginationModule,
    ReactiveFormsModule,
  ],
  templateUrl: './date-order-summary.component.html',
  styleUrl: './date-order-summary.component.css',
})
export class DateOrderSummaryComponent {
  userTypeList: any;
  selectedUserType: any;
  userById: undefined;
  selectedZoneId: any;
  zoneList: any;
  allUserList: any;
  userId: any;
  userName: any;
  companyName: any;
  userType: any;
  fromDate: any;
  toDate: any;
  searchText: string = '';
  isListShow: boolean = false;
  selectedUserId: any;
  selectedZoneName: any;
  selectedUserTypeId: any;
  orderSummaryData: any;
  isDateShow: boolean = false;
  selectedUserName: any;
  selectedCompanyName: any;
  totalSarReceivedFromRequester: number = 0;
  totalSarAllocatedToDumpster: number = 0;
  totalSarAllocatedToDumpyard: number = 0;
  totalSarAllocatedToSmartsort: number = 0;
  totalSarRefundedToRequester: number = 0;
  totalQuantityDisposed: number = 0;
  cityList: any;
  selectedCityId: any;
  isToDate: boolean = false;
  filteredUserList: any;

  constructor(
    private reportService: ReportsService,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private dashService: DashboardService,
    private loginService: LoginService
  ) {}

  // -------------------------------------- OnInit -------------------------------------- //

  ngOnInit() {
    this.getCity();
    this.getOrderSummary();
    this.allUsers();
    this.getUserType();
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.orderSummaryData);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'OrderSummaryReport.xlsx');
  }

  //  ----------------------------------- Get UserType List ----------------------------------- //

  getUserType() {
    this.reportService.getUserTypeList(apiEndPoints.userType).subscribe({
      next: (response: any) => {
        let userType = [1, 2, 3, 4];
        this.userTypeList = response.body.details.filter((user: any) =>
          userType.includes(user.id)
        );
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  filterUsers() {
    const search = this.searchText.toLowerCase();
    this.filteredUserList = this.allUserList.filter((user: any) => {
      return (
        user.userName?.toLowerCase().includes(search) ||
        user.companyName?.toLowerCase().includes(search) ||
        user.phoneNo?.toLowerCase().includes(search)
      );
    });
  }

  //  ----------------------------------- On UserType Change ----------------------------------- //

  onUserTypeChange(event: any) {
    const selectedUserType = (event.target as HTMLSelectElement).value;
    this.selectedUserType = selectedUserType;
    // this.orderSummaryData = [];
    this.userById = undefined;
    this.allUsers();
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body?.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.userById = undefined;
    this.getZone();
    this.allUsers();
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneName = selectedZoneId;
    this.allUsers();
  }

  // ----------------------------------- Get All Users ----------------------------------- //

  allUsers() {
    this.reportService
      .getAllUserSummary(
        apiEndPoints.summaryUserList,
        this.selectedUserType,
        this.selectedCityId,
        this.selectedZoneId
      )
      .subscribe({
        next: (response: any) => {
          let allowedTypes = ['1', '2'];
          this.allUserList = response.body?.details.filter((data: any) =>
            allowedTypes.includes(data.userType)
          );
          this.filteredUserList = [...this.allUserList];
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  getType(type: any): string {
    switch (type) {
      case '1':
      case 1:
        return 'Individual Requester';
      case '2':
      case 2:
        return 'Corporate Requester';
      case '3':
      case 3:
        return 'Dumpster';
      case '4':
      case 4:
        return 'Dumpyard';
      default:
        return 'Unknown';
    }
  }

  // ----------------------------------- Date Change ----------------------------------- //

  onDateChange(type: string, event: Event): void {
    this.isToDate = true;
    this.toDate = [];
    const value = (event.target as HTMLInputElement).value;
    if (type === 'from') {
      this.isDateShow = true;
      this.fromDate = value;
    } else if (type === 'to') {
      this.toDate = value;
      this.getOrderSummary();
    }
  }

  getUsersById(user: any) {
    this.selectedUserId = user.userId;
    this.selectedUserTypeId = user.userType;
    this.selectedUserName = user.userName;
    this.selectedCompanyName = user.companyName;
    this.getOrderSummary();
  }

  // ----------------------------------- Get Order Summary API ----------------------------------- //

  getOrderSummary() {
    this.isListShow = true;

    const reqBody: any = {
      cityId: this.selectedCityId,
      zoneName: this.selectedZoneName,
      userId: this.selectedUserId,
      userTypeId: this.selectedUserTypeId,
    };

    if (this.fromDate) {
      const [fromYear, fromMonth, fromDay] = this.fromDate.split('-');
      reqBody.fromDay = fromDay;
      reqBody.fromMonth = fromMonth;
      reqBody.fromYear = fromYear;
    }

    if (this.toDate) {
      if (new Date(this.toDate) < new Date(this.fromDate)) {
        this.toastr.info('To Date cannot be before From Date!', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true,
        });
        this.toDate = '';
        return;
      }
      const [toYear, toMonth, toDay] = this.toDate.split('-');
      reqBody.toDay = toDay;
      reqBody.toMonth = toMonth;
      reqBody.toYear = toYear;
    }

    this.reportService
      .getOrderSummaryByDate(apiEndPoints.OrderSummaryByDate, reqBody)
      .subscribe({
        next: (response: any) => {
          console.log('API Response:', response);
          if (response.isSuccess) {
            console.log('Order Summary Data:', response.body.details);
            this.orderSummaryData = response.body.details;
            this.calculateTotals();
          } else {
            console.warn('API response indicates failure:', response);
          }
        },
        error: (error: any) => {
          console.error('API call failed:', error);
        },
      });
  }

  calculateTotals() {
    this.totalSarReceivedFromRequester = 0;
    this.totalSarAllocatedToDumpster = 0;
    this.totalSarAllocatedToDumpyard = 0;
    this.totalSarAllocatedToSmartsort = 0;
    this.totalSarRefundedToRequester = 0;
    this.totalQuantityDisposed = 0;

    this.orderSummaryData.forEach((data: any) => {
      this.totalSarReceivedFromRequester += data.sarReceivedFromRequester || 0;
      this.totalSarAllocatedToDumpster += data.sarAllocatedToDumpster || 0;
      this.totalSarAllocatedToDumpyard += data.sarAllocatedToDumpyard || 0;
      this.totalSarAllocatedToSmartsort += data.sarAllocatedToSmartsort || 0;
      this.totalSarRefundedToRequester += data.sarRefundedToRequester || 0;
      this.totalQuantityDisposed += data.totalQuantityDisposed || 0;
    });
  }

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Order-Summary-Report.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Order Summary Report';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          const userName = `User Name : ${
            this.selectedUserTypeId == '1'
              ? this.selectedUserName
              : this.selectedCompanyName
          }`;
          const userNameX = 10; // Left alignment
          const userNameY = titleY + 5; // Adjusted to align with the table
          doc.setFontSize(10); // Reduced text size
          doc.text(userName, userNameX, userNameY, { align: 'left' });

          // Table headers
          const headers = [
            [
              { content: 'Order ID' },
              { content: 'City' },
              { content: 'Zone' },
              { content: 'Schedule Start Date' },
              { content: 'Schedule End Date' },
              { content: 'Number of Weeks' },
              { content: 'Number of Containers' },
              { content: 'Planned Trips' },
              { content: 'Actual Trips' },
              { content: 'SAR Received from Requester' },
              { content: 'SAR Allocated to Dumpster' },
              { content: 'SAR Allocated to Dumpyard' },
              { content: 'SAR Allocated to Smartsort' },
              { content: 'SAR Refunded to Requester' },
              { content: 'Total Quantity Disposed' },
            ],
          ];

          let tableBody: any[] = [];

          // Populate table body with data
          this.orderSummaryData.forEach((data: any) => {
            tableBody.push([
              data.orderId,
              data.city,
              data.zone,
              data.scheduleStartDate
                ? new Date(data.scheduleStartDate).toLocaleDateString()
                : '',
              data.scheduleEndtDate
                ? new Date(data.scheduleEndtDate).toLocaleDateString()
                : '',
              data.numberOfWeeks,
              data.numberOfContainers,
              data.plannedTrips,
              data.actualTrips,
              data.sarReceivedFromRequester,
              data.sarAllocatedToDumpster,
              data.sarAllocatedToDumpyard,
              data.sarAllocatedToSmartsort,
              data.sarRefundedToRequester,
              data.totalQuantityDisposed,
            ]);
          });

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
